import { ReactNode, useEffect } from "react";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { TopBar } from "./TopBar";
import { StructuredData, organizationSchema } from "@/components/StructuredData";

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  useEffect(() => {
    const id = "trustindex-richsnippet";
    if (!document.getElementById(id)) {
      const script = document.createElement("script");
      script.id = id;
      script.src = "https://cdn.trustindex.io/assets/js/richsnippet.js?88a650412434gddc";
      script.defer = true;
      script.async = true;
      document.head.appendChild(script);
    }
  }, []);

  return (
    <>
      <StructuredData data={organizationSchema} />
      <div className="flex flex-col min-h-screen">
        <div className="fixed top-0 left-0 right-0 z-50">
          <TopBar />
          <Header />
        </div>
        <main className="flex-1 pt-16 lg:pt-[116px]">{children}</main>
        <Footer />
      </div>
    </>
  );
}
